import React, { ChangeEvent, FC } from 'react'
import Button from '../button'
import QueryDate from '../orders/query-date'
import ItemSelector from './item-selector'
import { Item } from '../../../core/items'
import { Brand, BrandCode } from '../../../core/brands'
import styles from '../../styles/modules/item-price-history/item-price-history.module.scss'

export interface ItemPriceHistoryFilterForm {
  itemId: string
  dateFrom: Date | null
  dateTo: Date | null
  brandCode: string
}

interface Props {
  formState: ItemPriceHistoryFilterForm
  onChange: (field: 'itemId' | 'brandCode', value: string) => void
  onItemChange: (itemId: string) => void
  onClear: () => void
  onBrandChange: (brandCode: BrandCode | '') => void
  onChangeDateFrom: (date: Date | null) => void
  onChangeDateTo: (date: Date | null) => void
  items: Item[]
  brands: Brand[]
  isAdmin: boolean
  isLoading: boolean
}

const ItemPriceHistoryFilters: FC<Props> = ({
  formState,
  onChange,
  onItemChange,
  onClear,
  onBrandChange,
  onChangeDateFrom,
  onChangeDateTo,
  items,
  brands,
  isAdmin,
  isLoading,
}) => {
  const handleItemSelect = (itemId: string) => {
    onItemChange(itemId)
  }

  const handleBrandSelect = (event: ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value as BrandCode | ''
    onChange('brandCode', value)
    onBrandChange(value)
  }

  return (
    <div className={styles.queryContainer}>
      {isAdmin && (
        <div className={styles.field}>
          <span className={styles.label}>ブランド</span>
          <select
            id="brand"
            name="brandCode"
            className={styles.control}
            value={formState.brandCode || ''}
            onChange={handleBrandSelect}
          >
            {brands.length === 0 ? (
              <option value="@loading" disabled>
                ブランドを取得中...
              </option>
            ) : (
              brands.map(brand => (
                <option key={brand.code} value={brand.code}>
                  {brand.name}
                </option>
              ))
            )}
          </select>
        </div>
      )}

      <div className={styles.field}>
        <span className={styles.label}>コーヒー</span>
        <ItemSelector
          items={items}
          selectedItemId={formState.itemId}
          onItemChange={handleItemSelect}
        />
      </div>

      <QueryDate
        from={formState.dateFrom}
        to={formState.dateTo}
        onChangeFrom={onChangeDateFrom}
        onChangeTo={onChangeDateTo}
      />

      <div className={styles.actions}>
        <Button
          title="クリア"
          onClick={onClear}
          isLoading={isLoading}
          className={styles.searchButton}
        />
      </div>
    </div>
  )
}

export default ItemPriceHistoryFilters
